<template>
  <input
    type="date"
    :value="modelValue"
    @change="emitChange()"
    @blur="emitBlur"
    ref="input"
    :placeholder="this.$t('global.date_format')"
  />
</template>

<script>
import Pikaday from 'pikaday'
import Locale from '../vue-i18n-locales.generated'

export default {
  props: {
    modelValue: { required: false },
  },
  data() {
    return {
      native: true,
    }
  },
  methods: {
    emitChange() {
      if (!this.native) {
        return
      }
      this.$emit('update:modelValue', this.$refs.input.value)
    },
    emitBlur() {
      this.$emit('blur', this.$refs.input.value)
    },
  },
  mounted() {
    if (!Modernizr.inputtypes.date) {
      this.native = false

      const picker = new Pikaday({
        field: this.$refs.input,
        i18n: Locale[window.lang].date_picker.i18n,
        onSelect: () => {
          this.$emit('update:modelValue', picker.toString())
        },
      })
    }
  },
  emits: ['update:modelValue', 'blur'],
}
</script>
